'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('../utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _Constants = require('../Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _PluginConfiguration = require('../PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

var _Plugin = require('../Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _PluginState = require('../PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

var _Framework = require('./Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _EventManager = require('./EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _log = require('../utility/log');

var _log2 = _interopRequireDefault(_log);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 用于从插件集合根目录中发现和加载插件，加载后，保存在plugins中
 * 
 * @ignore
 * @export
 * @class PluginInstaller
 */
var PluginInstaller = function () {

    /**
     * 创建一个实例
     * 
     * @ignore
     * @param {Framework} framework 框架实例
     * @memberof PluginInstaller
     */
    function PluginInstaller(framework) {
        (0, _classCallCheck3.default)(this, PluginInstaller);

        _Assert2.default.notNull('framework', framework);

        this.framework = framework;
        this.pluginsDirectories = framework.pluginsDirectories;
        this.eventManager = framework.eventManager;
        this.plugins = new _map2.default();

        this.dispose = this.dispose.bind(this);

        this.installPlugins = this.installPlugins.bind(this);
        this.installPluginInternal = this.installPluginInternal.bind(this);
        this.installPlugin = this.installPlugin.bind(this);

        this.getPlugin = this.getPlugin.bind(this);
        this.getPlugins = this.getPlugins.bind(this);
    }

    /**
     * 清理资源
     * 
     * @memberof PluginInstaller
     */


    (0, _createClass3.default)(PluginInstaller, [{
        key: 'dispose',
        value: function dispose() {
            this.plugins.clear();
        }

        /**
         * 获取插件
         * 
         * @param {string} id 
         * @returns {Plugin} 插件实例
         * @memberof PluginInstaller
         */

    }, {
        key: 'getPlugin',
        value: function getPlugin(id) {
            _Assert2.default.notEmpty('pluginId', id);

            if (!this.plugins.has(id)) {
                return null;
            }
            return this.plugins.get(id);
        }

        /**
         * 获取所有插件
         * 
         * @returns {Map.<string, Plugin>}
         * @memberof PluginInstaller
         */

    }, {
        key: 'getPlugins',
        value: function getPlugins() {
            return this.plugins;
        }

        /**
         * 从插件集合目录中查找插件，规则为：插件根目录——插件目录(多级）——plugin.json（插件目录的文件），
         * 如果找到plugin.json，则尝试加载解析插件
         * 
         * @memberof PluginInstaller
         */

    }, {
        key: 'installPlugins',
        value: function installPlugins(pluginsDirectories) {
            if (!pluginsDirectories) pluginsDirectories = this.pluginsDirectories; //默认从插件根目录加载
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(pluginsDirectories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pluginsDirectory = _step.value;

                    _log2.default.logger.info('Loading plugins from ' + pluginsDirectory + '.');
                    var subPluginsDirectories = _fs2.default.readdirSync(pluginsDirectory);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(subPluginsDirectories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var subPluginDirectory = _step2.value;

                            subPluginDirectory = _path2.default.join(pluginsDirectory, subPluginDirectory);
                            var pluginConfigFile = _path2.default.join(subPluginDirectory, _Constants2.default.pluginConfigFileName);

                            if (!_fs2.default.existsSync(pluginConfigFile)) {
                                //找到config文件，表明是plugin
                                this.installPlugins([subPluginDirectory]);
                            } else {
                                //查找二级目录下的plugin
                                this.installPluginInternal(subPluginDirectory);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _log2.default.logger.info('Plugins are loaded from ' + pluginsDirectory + ' completed.');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            _log2.default.logger.info('There are ' + this.plugins.size + ' plugins loaded.');
        }

        /**
         * 加载一个插件，内部使用，返回一个插件对象
         * 
         * @param {string} pluginDirectory 插件目录
         * @returns {Plugin} 插件对象
         * @memberof PluginInstaller
         */

    }, {
        key: 'installPluginInternal',
        value: function installPluginInternal(pluginDirectory) {
            var pluginConfigFile = _path2.default.join(pluginDirectory, _Constants2.default.pluginConfigFileName);
            if (!_fs2.default.existsSync(pluginConfigFile)) {
                return null;
            }

            var pluginConfiguration = null;

            try {
                pluginConfiguration = new _PluginConfiguration2.default(pluginConfigFile);
            } catch (error) {
                _log2.default.logger.error('Failed load plugin from ' + pluginDirectory + ' since plugin config file ' + pluginConfigFile + ' can not be found.', error);
                return null;
            }

            if (this.plugins.has(pluginConfiguration.id)) {
                _log2.default.error('Failed to load plugin from ' + pluginDirectory + ' since duplicated plugin id with ' + this.plugins.get(pluginConfiguration.id).pluginDirectory + '.');
                return null;
            }

            var plugin = new _Plugin2.default(this.framework, pluginDirectory, pluginConfiguration);
            this.plugins.set(plugin.id, plugin);
            _log2.default.logger.info('Plugin ' + pluginConfiguration.id + ' is loaded from ' + pluginDirectory + '.');

            this.eventManager.firePluginStateChanged(plugin.id, null, _PluginState2.default.INSTALLED);
            return plugin;
        }

        /**
         * 加载一个插件，并执行解析
         * 
         * @param {string} pluginDirectory 
         * @returns {Plugin} 插件对象
         * @memberof PluginInstaller
         */

    }, {
        key: 'installPlugin',
        value: function installPlugin(pluginDirectory) {
            var plugin = this.installPluginInternal(pluginDirectory);
            if (plugin != null) {
                // 将插件添加到解析列表
                this.framework.pluginResolver.add(plugin.pluginConfiguration);
            }
            return plugin;
        }
    }]);
    return PluginInstaller;
}();

exports.default = PluginInstaller;
//# sourceMappingURL=PluginInstaller.js.map